import { render, staticRenderFns } from "./myFileDia.vue?vue&type=template&id=3b3be450&scoped=true"
import script from "./myFileDia.vue?vue&type=script&lang=js"
export * from "./myFileDia.vue?vue&type=script&lang=js"
import style0 from "./myFileDia.vue?vue&type=style&index=0&id=3b3be450&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3be450",
  null
  
)

export default component.exports